import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {UserAction} from '../actions/UserAction'
import {CommonAction} from '../actions/CommonAction'

import logo from '../assets/img/logo/logo.png'
import logoBlue from '../assets/img/logo/logo-blue.svg'
import AuthService from "../services/auth.service"
import {LOG_OUT} from "../constants"
import i18n from "i18next"
import {Link, NavLink} from "react-router-dom";
import Language from "./Language";
import $ from "jquery";

class Header extends Component {

    componentDidMount() {
        $('.navigation li').not('.dropdown').on('click', () => {
            $('.navbar-collapse-one').collapse('hide')
        })
    }

    logout(e) {
        e.preventDefault()

        AuthService.logout()
        this.props.userAction(LOG_OUT)
    }

    render() {

        const currentUser = AuthService.getCurrentUser();
        const isAuthenticated = currentUser && currentUser.accessToken && currentUser.accessToken !== "";

        const showConsole = AuthService.hasRole("CONSOLE");
        const showAccount = AuthService.hasRole("COMPANY_ADMIN");
        const showExcelSearch = AuthService.hasRole("EXCEL_SEARCH");
        const showReports = AuthService.hasRole("REPORTS");
        const showTx = AuthService.hasRole("TM");
        const showSimulate = AuthService.hasRole("TM_SIMULATE");

        return (
            <>
                <header className="main-header">
                    <div className="header-style">
                        <div className="container">

                            <div className="header-inner clearfix d-lg-flex">
                                <div className="logo-outer">
                                    <div className="logo">
                                        <Link to="/">
                                            <img src={logo} alt="Search Sanctions AML Solutions" title="" width="250px"/>
                                        </Link>
                                    </div>
                                    <div className="fixed-logo">
                                        <Link to="/">
                                            <img src={logoBlue} alt="Search Sanctions AML Solutions" title=""/>
                                        </Link>
                                    </div>
                                </div>

                                <nav className="main-menu navbar-expand-md ml-md-auto">

                                    <div className="navbar-header clearfix">
                                        <div className="logo">
                                            <Link to="/">
                                                <img src={logo} alt="Search Sanctions AML Solutions" title=""/>
                                            </Link>
                                        </div>
                                        <div className="fixed-logo">
                                            <Link to="/">
                                                <img src={logoBlue} alt="Search Sanctions AML Solutions" title="" className="img-mobile"/>
                                            </Link>
                                        </div>

                                        <button type="button" className="navbar-toggle" data-toggle="collapse"
                                                data-target=".navbar-collapse-one">
                                            <span className="icon-bar"/>
                                            <span className="icon-bar"/>
                                            <span className="icon-bar"/>
                                        </button>
                                    </div>

                                    <div className="navbar-collapse navbar-collapse-one collapse clearfix">

                                        <ul className="navigation clearfix">
                                            {isAuthenticated &&
                                                <>
                                                    {/*<li>*/}
                                                    {/*    <NavLink to="/documentation">{i18n.t('apidoc')}</NavLink>*/}
                                                    {/*</li>*/}
                                                    {showConsole &&
                                                        <>
                                                            <li>
                                                                <NavLink to="/console">{i18n.t('console')}</NavLink>
                                                            </li>
                                                        </>
                                                    }
                                                    {showExcelSearch &&
                                                        <>
                                                            <li>
                                                                <NavLink to="/excel-search">{i18n.t('multiSearch')}</NavLink>
                                                            </li>
                                                        </>
                                                    }
                                                    {showReports &&
                                                        <>
                                                            <li>
                                                                <NavLink to="/reports">{i18n.t('reports')}</NavLink>
                                                            </li>
                                                        </>
                                                    }
                                                    {showTx &&
                                                        <>
                                                            <li>
                                                                <NavLink to="/transaction-monitoring">{i18n.t('transactionMonitoring')}</NavLink>
                                                            </li>
                                                            <li>
                                                                <NavLink to="/customer-profile">{i18n.t('customerProfile')}</NavLink>
                                                            </li>
                                                        </>
                                                    }
                                                    {showSimulate &&
                                                        <>
                                                            <li>
                                                                <NavLink to="/tx-paytest">{i18n.t('simulate')}</NavLink>
                                                            </li>
                                                        </>
                                                    }
                                                    {/*<li>*/}
                                                    {/*    <NavLink to="/contact">{i18n.t('contact')}</NavLink>*/}
                                                    {/*</li>*/}
                                                    {showAccount &&
                                                        <>
                                                            <li>
                                                                <NavLink to="/account">{i18n.t('account')}</NavLink>
                                                            </li>
                                                        </>
                                                    }
                                                    <li>
                                                        <a onClick={(e) => {
                                                            this.logout(e)
                                                        }}
                                                           href="#">
                                                            {i18n.t('logout')}
                                                            {/*<LogoutOutlined style={{marginLeft: '5px', fontSize: '21px'}}/>*/}
                                                        </a>
                                                    </li>
                                                </>
                                            }

                                            <li className="dropdown">
                                                <Language/>
                                            </li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </header>

                <section className="bg-grad header-sub-section"/>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)